import axios from 'axios'
import { TASK_DETAIL } from '@/utils/constants'

const baseUrl = '/taskserver/api/v1'

export default {

  /**
   * 日历日程任务
   * @param {Object} params 参数项
   */
  getMyTasks (data) {
    return axios.post(`${baseUrl}/tasks/calendar/myTasks`, data)
  },
  /**
   * 日历任务查询接口（负责的，创建的，关注的）
   * @param {请求参数} params
   * @param {responsible:我负责的（默认），created:我创建的，favorite:我关注的} type
   */
  getCalendarTask (params = {}) {
    return axios.post(`${baseUrl}/tasks/calendar/responsibleTasks`, params)
  },
  /**
   * 项目下日历任务查询接口
   * @param {*} params
   */
  getMatterCalendarTask (params = {}) {
    return axios.get(`${baseUrl}/tasks/calendar/matterTasks`, { params })
  },
  /**
   * 修改任务状态
   * @param {*} taskId
   * @param {*} state
   */
  changeTaskState (taskId, state) {
    const url = `/taskserver/api/v1/tasks/${taskId}/${state === TASK_DETAIL.STATE_FINISHED ? 'finish' : 'restart'}`
    return axios.put(url, {})
  },
  /**
   * 修改任务的起止时间
   * 只设置非重复任务和日程
   * @param {Object} params
   */
  resetTaskTime (params) {
    const url = `/taskserver/api/v1/tasks/${params.id}/time`
    params.effectRepeats = false
    return axios.put(url, params)
  },
  /**
   * 查询时间段内的假期
   */
  getRestInfoInterval (params) {
    return axios.get('/common/api/v1/calculate/getRestInfoInterval', { params })
  }
}
